export default __webpack_public_path__ + "static/media/sappito_tech_iso.1c175e32.png";